const NAV_DEBUG_ALLOWED_EMAILS = new Set<string>([
  "stefff@yahoo.com",
  "stefan.andonov@yahoo.com",
  "stefan.andonov1@yahoo.com",
  "ios@yahoo.com",
  "stan@ingy.nl",
  "stan.vdkroon279@gmail.com",
  "hungphu452@gmail.com",
  "alfather49@gmail.com",
  "rusrares11@gmail.com",
  // Dedicated diagnostics test account — a STANDING grant, not a temporary one.
  // Mirrors PROD_DEBUG_ALLOWED_EMAILS in the RN repo (src/lib/native/debug-access.ts):
  // both halves must agree, or the app shows a Submit button that this route then
  // rejects. A clean account reproduces bugs the owner's long-lived accounts cannot
  // (the null-clientId RLS-42501 blocked-outbox capture it was first added for is
  // one such case), so it keeps this access on an ongoing basis.
  "debug_test@mail.com",
]);

export function isNavDebugAllowedEmail(email: string | null | undefined): boolean {
  const normalized = (email || "").trim().toLowerCase();
  if (!normalized) return false;
  return NAV_DEBUG_ALLOWED_EMAILS.has(normalized);
}
